define('modules/degree-dimming',[
    'domReady',
    'jquery',
    'underscore',
    'velocity',
    'velocity.ui'
],  function (domReady, $, _) {
    'use strict';

    console.log('%cfile: degree-dimming.js', 'color: #C2ECFF');

    var _this,
        _defaults = {
            elements: {
                slider: '.js__degree-dimming-ui',
                container: '[data-transitions-lens]',
                lens: '.js__degree-dimming-lens'
            },
            $elements: {},
            maxRotate: 140,
            maxOpacity: 1,
            minOpacity: 0.14
        };

    /** constructor */
    function Module(){
        console.log('%ctrace: DegreeDimming -> constructor', 'color: #ccc');

        _this = this;

        domReady(function () {
            console.log('%ctrace: DegreeDimming -> constructor -> domReady', 'color: #ccc');

            domElementsUpdates();

            if (_defaults.$elements.slider.length <= 0) {
                return false;
            }

            if (!window.Draggable) {
                return false;
            }

            TweenLite.set('.js__degree-dimming-ui', { rotation: _defaults.maxRotate, opacity: 1 });
            TweenLite.to('.js__degree-dimming-ui', 2, { ease: Elastic.easeInOut.config(1, 0.5), rotation: 0 });

            Draggable.create('.js__degree-dimming-ui', {
                type: 'rotation',
                edgeResistance: 0.8,
                throwProps: true,
                bounds: {
                    minRotation: 0,
                    maxRotation: _defaults.maxRotate
                },
                snap: function(endValue) {
                    return Math.round(endValue / _defaults.maxRotate) * _defaults.maxRotate;
                },
                onDrag: function() {
                    var opacity = 1 - this.rotation / _defaults.maxRotate;

                    if (opacity <= _defaults.minOpacity) {
                        opacity = _defaults.minOpacity
                    }

                    _defaults.$elements.lens.css('opacity', opacity);
                },
                onDragStart: function() {

                },
                onThrowComplete: function() {
                    var opacity;

                    if (this.endRotation <= 10) {
                        _defaults.$elements.container.attr('data-transitions-lens', 'sun');
                        opacity = _defaults.maxOpacity;
                    } else {
                        _defaults.$elements.container.attr('data-transitions-lens', 'indoors');
                        opacity = _defaults.minOpacity;
                    }

                    _defaults.$elements.lens.velocity('stop').velocity({
                        'opacity': opacity
                    }, {
                        duration: 300,
                        mobileHA: true
                    });
                }
            });
        });
    }

    function domElementsUpdates(){
        console.log('%ctrace: DegreeDimming -> domElementsUpdates', 'color: #ccc');

        _.forEach(_defaults.elements, function(value, key){
            _defaults.$elements[key] = $(value);
        });
    }

    return Module;
});

